export const DIALOG_ROOT_ID = 'dialogRootElement';
export enum DIALOG_TYPE {
  ALERT = 'alert',
  CONFIRM = 'confirm',
}

export enum DIALOG_TEXT_TYPE {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  SUCCESS = 'success',
}
